export default {

  // Global
  "lang": "ar",
  "home": "الرئيسية",
  "services": "الخدمات",
  "process": "العملية",
  "price": "الأسعار",
  "faq": "الأسئلة الشائعة",
  "contact": "اطلب الآن",
  "button": "احجز الآن",
  "button2": "إرسال الطلب",
  "loading": "جار التحميل",
  "reviews": "تقييمات",
  "review": "تقييم",
  "clear": "حذف",
  "clear2": "حذف",
  "agb": "الشروط والأحكام",
  "privacy_policy": "سياسة الخصوصية",
  "legal": "قانوني",
  "impressum": "بيانات الشركة",
  "name_surname": "الاسم الكامل",
  "buy_reviews": "شراء تقييمات",
  "visit_us": "تفضل بزيارتنا للاطلاع على التفاصيل",
  "buy_clear": "حذف تقييمات",
  "copyright": "حقوق النشر محفوظة منذ ©2011 جميع الحقوق محفوظة",
  "address": "طريق الملك فهد، حي العليا، الرياض 12211، المملكة العربية السعودية",
  "slogan": "نحن نحمي سمعتك!",
  "email_required": "البريد الإلكتروني مطلوب",
  "email_invalid": "صيغة البريد الإلكتروني غير صحيحة",
  "phone_required": "رقم الهاتف مطلوب",
  "phone_invalid": "صيغة رقم الهاتف غير صحيحة",
  "package_id_required": "الباقة مطلوبة",
  "phone": "رقم الهاتف",
  "order_complete": "تم استلام رسالتك بنجاح",
  "order_not_complete": "تعذر استلام رسالتك",
  "message": "ملاحظات إضافية",
  "email": "البريد الإلكتروني",
  "kdv": "شامل الضريبة",
  "positive": "إيجابي",
  "negative": "سلبي",
  "garantie": "ضمان الرضا",
  "loschungData": "لكل تقييم <br/> يتم حذفه / سعر القطعة",
  "select_package": "أي باقة تهمك؟",
  "basic": "مبتدئ",
  "business": "بزنس",
  "pro": "برو",
  "loschung1": "حتى",
  "loschung2": "من",

  "url_google": "شراء-تقييمات-جوجل",
  "url_google_local_guide": "شراء-تقييمات-جوجل-المرشد-المحلي",
  "url_trustpilot": "شراء-تقييمات-تراستبايلوت",
  "url_arbeitgeber": "شراء-تقييمات-صاحب-العمل",
  "url_google_clear": "حذف-تقييمات-جوجل",
  "url_wunschplattform": "شراء-تقييمات-منصة-مخصصة",

  "employer": "أصحاب العمل",
  "wunschplattform": "المنصة المخصصة",

  // Home Hero
  "home_hero_title": "<h1>تقييمات جوجل <br/> احترافية، سرية <br/> وأصلية.</h1>",
  "home_hero_description": "هي نقطة انطلاق سمعتك ونجاحك! وثق بقوة الآراء!",
  "home_hero_list_item1": "محتوى مخصص",
  "home_hero_list_item2": "جدول زمني مخصص",
  "home_hero_list_item3": "ضمان لمدة 6 أشهر",
  "home_hero_button": "تحقق من الأسعار",

  "rating": "مع 35,000 شركة نخدمها ونسبة رضا 98%، أثبتنا أن رضا العملاء هو هدفنا الأول.",

  // Home Steps
  "home_step1_title": "مستخدمون حقيقيون، ليسوا روبوتات.",
  "home_step1_description": "من الضروري الحصول على تقييمات من مستخدمين حقيقيين والابتعاد عن تقييمات الروبوتات المُبرمجة. معنا تحصل فقط على تقييمات من مستخدمين محليين موثقين.",
  "home_step1_list_item1": "أكثر من 50,000 مُقيِّم في جميع أنحاء فرنسا",
  "home_step1_list_item2": "أسماء فرنسية، حسابات موثقة",
  "home_step1_list_item3": "صور شخصية طبيعية وتاريخ حقيقي",
  "home_step2_title": "تقييمات جوجل",
  "home_step2_description": "<p>تكمن أهمية تقييمات جوجل في كونها تؤثر بشكل كبير على ثقة العملاء وقراراتهم الشرائية. <br/> <br/> إنها تمنح العملاء فرصة الاطلاع على تجارب الآخرين واستخلاص استنتاجات حول رضا العملاء وسمعة الشركة. <br/> <br/> يمكن للتقييمات الإيجابية أن تزيد الثقة والاستعداد للشراء، في حين يمكن للتقييمات السلبية أن تثبط العملاء المحتملين. لذلك، لتقييمات جوجل تأثير مباشر على نجاح الشركة وسمعتها في العصر الرقمي.</p>",
  "home_step3_title": "لماذا يجب شراء تقييمات؟",
  "home_step3_description": "<p>وفقاً لاستطلاع أجرته BrightLocal، أفاد 86% من المستهلكين بأنهم يثقون بالتقييمات الإلكترونية تماماً كما يثقون بالتوصيات الشخصية. <br/> <br/> وجدت دراسة أجرتها Harvard Business School أن زيادة نجمة واحدة في التقييم يمكن أن تؤدي إلى زيادة متوسط في المبيعات يتراوح بين 5% و9%. <br/> <br/> وفقاً لدراسة أجرتها Moz، فإن عدد ونوعية التقييمات لهما تأثير مباشر على ترتيب الشركة في نتائج البحث المحلية. <br/> <br/> يُظهر استطلاع أجرته ReviewTrackers أن 94% من المستهلكين يقرؤون التقييمات السلبية قبل اتخاذ قرار الشراء. وهذا يؤكد أهمية أخذ التقييمات السلبية على محمل الجد والرد عليها.</p>",

  // Prices
  "price_description": "بدون اشتراك، حجز واحد فقط - مرن وبسيط للحصول على الخدمة التي تريدها.",
  "price_total": "المجموع",

  // Services
  "services_title": "ما هي عملية نشر التقييم الإيجابي؟",
  "services_item1_title": "اختر الباقة المناسبة لك",
  "services_item1_description": "اختر من بين الباقات الخاصة بكل منصة الباقة المناسبة لك",
  "services_item2_title": "حدد تفاصيل حملتك",
  "services_item2_description": "سيتواصل معك مستشارو خدمة العملاء لمناقشة الحملة.",
  "services_item3_title": "محتوى النص",
  "services_item3_description": "زودنا بنصوصك الخاصة أو دعنا نتكفل بكتابتها. بالطبع تتناسب مع شركتك.",
  "services_item4_title": "الصور في التقييمات",
  "services_item4_description": "إذا رغبت، يمكننا إضافة بعض الصور إلى التقييمات. يجب أن تزودنا بها.",
  "services_item5_title": "بدء النشر",
  "services_item5_description": "بمجرد اتخاذ الترتيبات، نبدأ النشر. لن تحتاج للقلق بشأن أي شيء.",
  "services_item6_title": "تقارير الأنشطة",
  "services_item6_description": "بعد الانتهاء من النشر، ستتلقى تقريراً مفصلاً عن التقييمات المقدمة.",

  // Platform
  "platform_title": "نحن لسنا مجرد خبراء جوجل",

  // FAQ
  "faq_title": "الأسئلة المتكررة",
  "question_1": "هل يمكن شراء تقييمات جوجل؟",
  "answer_1": "تعد Taliqat123.com.sa الرائدة في سوق إدارة السمعة وتقدم منذ عام 2011 تقييمات احترافية وعالية الجودة.",
  "question_2": "كم تكلفة تقييم جوجل واحد؟",
  "answer_2": "تعد تقييمات جوجل الإيجابية أبسط وأرخص طريقة لاكتساب عملاء جدد وزيادة المبيعات بشكل ملحوظ. مقابل 750.00€ فقط، تحصل على 25 تقييماً عالي الجودة من جوجل.",
  "question_3": "هل يمكن شراء تقييمات جوجل سيئة؟",
  "answer_3": "في Taliqat123.com.sa، يمكنك شراء التقييمات الإيجابية فقط وحذف التقييمات السلبية. نحن لا نقدم تقييمات سلبية.",
  "question_4": "كم تكلفة حذف تقييم جوجل؟",
  "answer_4": "يبدأ حذف التقييم السلبي من 300.00€.",
  "question_5": "لماذا يحذف جوجل التقييمات الإيجابية؟",
  "answer_5": "يمكن لجوجل حذف التقييمات الإيجابية إذا لم تلتزم بإرشاداته. لذلك يجب تقديمها وفقاً لمعايير جوجل. بالإضافة إلى ذلك، يمكن لخوارزميات جوجل اكتشاف التقييمات المُبرمجة. لهذا السبب من المهم جداً الحصول على تقييمات من موردين محترفين ومستخدمين موثقين لديهم.",
  "question_6": "ما مدى أهمية تقييمات جوجل؟",
  "answer_6": "يمكن أن تكون <strong>تقييمات جوجل</strong> مصدراً قيماً للمعلومات للتعرف على شركة أو منتج أو خدمة. فيما يلي بعض العوامل التي قد تؤثر على مدى أهمية تقييمات جوجل:<br/> <br/> 1 - عدد التقييمات: يعطي العدد الأكبر من التقييمات صورة شاملة أفضل ويقلل من خطر الآراء الفردية التي قد لا تكون ممثلة.<br/> <br/> 2 - جودة التقييمات: يُنصح بعدم التركيز فقط على عدد النجوم. تقدم التقييمات المفصلة والشاملة فهماً أعمق وقد تولد ثقة أكبر.<br/> <br/> 3 - تنوع التقييمات: من المفيد الاطلاع على تقييمات أشخاص مختلفين بوجهات نظر متنوعة للحصول على صورة متوازنة.<br/> <br/> 4 - حداثة التقييمات: من المهم ملاحظة أن أداء الشركة يمكن أن يتغير بمرور الوقت. لذلك، يجب إيلاء أهمية أكبر للتقييمات الأحدث مقارنة بالأقدم.",
  "question_7": "هل يمكنني التقييم على جوجل بنفسي؟",
  "answer_7": "بالطبع يمكنك أيضاً تقديم تقييم كمستخدم لجوجل، ولكن يجب ألا يكون ملف التعريف المُقيَّم هو ملفك الشخصي.",

  // Process
  "process_hero_title": "اشترِ تقييمات <br/> بسهولة <br/> الآن.",
  "process_hero_description": "لدينا فريق ممتاز من الخبراء يقدمون خدمات عالية الجودة ويرافقون عملاءنا في كل خطوة. نقدم خدمة التقييمات منذ بدايات التجارة الإلكترونية، عندما أصبحت المكان الرئيسي للتسويق.",

  "process_step_1_title": "تقييمات جوجل",
  "process_step_1_description": "يعزز محرك بحث جوجل إمكانات الشركات من خلال تمكينها من الظهور في أعلى القائمة. <br/> <br/> لذلك، يفضل أولئك الذين يستخدمون نظام الملاحة الشركات التي تظهر في المراتب العليا.",

  "process_step_2_title": "لماذا يجب أن أشتري تقييمات خرائط جوجل؟",
  "process_step_2_description": "يعد عدد التعليقات التي تتلقاها الشركة مهماً دائماً للزوار. فالشركات ذات التعليقات القليلة والنجوم القليلة يفضلها الزوار بشكل أقل، لأنها لا تبعث الثقة. لذلك، تعد خدمة تقييمات خرائط جوجل ضرورية.",

  "process_step_3_title": "تقييمات جوجل",
  "process_step_3_description": "يعزز محرك بحث جوجل إمكانات الشركات من خلال تمكينها من الظهور في أعلى القائمة. <br/> <br/> لذلك، يفضل أولئك الذين يستخدمون نظام الملاحة الشركات التي يظهرون في المراتب العليا.",

  "process_step_4_title": "لماذا يجب أن أشتري تقييمات خرائط جوجل؟",
  "process_step_4_description": "يعد عدد التعليقات التي تتلقاها الشركة مهماً دائماً للزوار. فالشركات ذات التعليقات القليلة والنجوم القليلة يفضلها الزوار بشكل أقل، لأنها لا تبعث الثقة. لذلك، تعد خدمة تقييمات خرائط جوجل ضرورة من ضروريات عملك.",

  "process_services_title": "كيف تتم عملية نشر التعليق الإيجابي؟",
  "process_services_description_1": "<p>أسرع وأكثر الطرق فعالية للتفوق على المنافسين هي الحصول على مزيد من الظهور من خلال تقييمات العملاء الإيجابية.</p><br/><p> وفقاً للدراسات الحديثة، يختار 86% من جميع العملاء الشركة التي لديها أكبر عدد من التقييمات وأفضل متوسط تقييم في نتائج البحث. <br/> أسرع وأكثر الطرق فعالية للتفوق على المنافسين هي الحصول على مزيد من الظهور من خلال تقييمات العملاء الإيجابية.</p><br/><p> وفقاً للدراسات الحديثة، يختار 86% من جميع العملاء الشركة التي لديها أكبر عدد من التقييمات وأفضل متوسط تقييم في نتائج البحث.</p>",
  "process_services_description_2": "<p>أسرع وأكثر الطرق فعالية للتفوق على المنافسين هي الحصول على مزيد من الظهور من خلال تقييمات العملاء الإيجابية.</p><br/><p> وفقاً للدراسات الحديثة، يختار 86% من جميع العملاء الشركة التي لديها أكبر عدد من التقييمات وأفضل متوسط تقييم في نتائج البحث. <br/>أسرع وأكثر الطرق فعالية للتفوق على المنافسين هي الحصول على مزيد من الظهور من خلال تقييمات العملاء الإيجابية.</p><br/><p> وفقاً للدراسات الحديثة، يختار 86% من جميع العملاء الشركة التي لديها أكبر عدد من التقييمات وأفضل متوسط تقييم في نتائج البحث.</p>",

  // Prices Data
  "data": [
    {
      "Google": [
        {
          "title": "جوجل ستارتر",
          "proBewertung": "10",
          "value": "547",
          "price": "320",
          "features": [
            "مستخدمون محليون موثقون",
            "وتيرة مخصصة",
            "نصوص مخصصة"
          ]
        },
        {
          "title": "جوجل مبتدئ",
          "proBewertung": "25",
          "value": "85",
          "price": "750",
          "features": [
            "مستخدمون محليون موثقون",
            "وتيرة مخصصة",
            "نصوص مخصصة"
          ]
        },
        {
          "title": "جوجل بزنس",
          "proBewertung": "50",
          "value": "86",
          "price": "1350",
          "features": [
            "مستخدمون محليون موثقون",
            "وتيرة مخصصة",
            "نصوص مخصصة",
            "لوحة تحكم شخصية"
          ]
        },
        {
          "title": "جوجل برو",
          "proBewertung": "100",
          "value": "88",
          "price": "2400",
          "features": [
            "تتضمن 10 تقييمات Local Guide",
            "مستخدمون محليون موثقون",
            "وتيرة مخصصة",
            "نصوص مخصصة",
            "لوحة تحكم شخصية",
            "قابل للتوزيع على عدة ملفات/مواقع شخصية"
          ]
        }
      ],
      "Google Local Guide": [
        {
          "title": "جوجل المرشد المحلي للمبتدئين",
          "proBewertung": "25",
          "value": "92",
          "price": "750",
          "features": [
            "مستخدمون محليون موثقون",
            "وتيرة مخصصة",
            "نصوص مخصصة"
          ]
        },
        {
          "title": "جوجل المرشد المحلي بزنس",
          "proBewertung": "50",
          "value": "94",
          "price": "1350",
          "features": [
            "مستخدمون محليون موثقون",
            "وتيرة مخصصة",
            "نصوص مخصصة",
            "لوحة تحكم شخصية"
          ]
        },
        {
          "title": "جوجل المرشد المحلي برو",
          "proBewertung": "100",
          "value": "95",
          "price": "2400",
          "features": [
            "مستخدمون محليون موثقون",
            "وتيرة مخصصة",
            "نصوص مخصصة",
            "لوحة تحكم شخصية",
            "قابل للتوزيع على عدة ملفات/مواقع شخصية"
          ]
        }
      ],
      "Trustpilot": [
        {
          "title": "تراستبايلوت مبتدئ",
          "proBewertung": "25",
          "value": "400",
          "price": "650",
          "features": [
            "مستخدمون محليون موثقون",
            "وتيرة مخصصة",
            "نصوص مخصصة"
          ]
        },
        {
          "title": "تراستبايلوت بزنس",
          "proBewertung": "50",
          "value": "401",
          "price": "1200",
          "features": [
            "مستخدمون محليون موثقون",
            "وتيرة مخصصة",
            "نصوص مخصصة",
            "لوحة تحكم شخصية"
          ]
        },
        {
          "title": "تراستبايلوت برو",
          "proBewertung": "100",
          "value": "402",
          "price": "1950",
          "features": [
            "مستخدمون محليون موثقون",
            "وتيرة مخصصة",
            "نصوص مخصصة",
            "لوحة تحكم شخصية",
            "قابل للتوزيع على عدة ملفات/مواقع شخصية"
          ]
        }
      ],
      "Arbeitgeber": [
        {
          "title": "أصحاب العمل مبتدئ",
          "proBewertung": "25",
          "value": "403",
          "price": "600",
          "features": [
            "مستخدمون محليون موثقون",
            "وتيرة مخصصة",
            "نصوص مخصصة"
          ]
        },
        {
          "title": "أصحاب العمل بزنس",
          "proBewertung": "50",
          "value": "404",
          "price": "1100",
          "features": [
            "مستخدمون محليون موثقون",
            "وتيرة مخصصة",
            "نصوص مخصصة",
            "لوحة تحكم شخصية"
          ]
        },
        {
          "title": "أصحاب العمل برو",
          "proBewertung": "100",
          "value": "405",
          "price": "1800",
          "features": [
            "مستخدمون محليون موثقون",
            "وتيرة مخصصة",
            "نصوص مخصصة",
            "لوحة تحكم شخصية",
            "قابل للتوزيع على عدة ملفات/مواقع شخصية"
          ]
        }
      ],
      "Google Loschen": [
        {
          "title": "جوجل حذف بزنس",
          "titleleft": "كم عدد التقييمات السلبية التي تريد حذفها؟",
          "leftdesc1": "نساعدك على حذف التقييمات غير المرغوب فيها وغير الدقيقة بسهولة وسرعة، لأنك لا يجب أن تتسامح مع الانتقادات التشهيرية!",
          "leftdesc2": "بدون مخاطر مالية - الدفع فقط عند النجاح!",
          "rangeTitle": "عدد التقييمات المراد حذفها",
          "rangeText": "توفر",
          "name": "تقييمات سلبية",
          "garantie": "ضمان الرضا",
          "proBwt": "لكل تقييم يتم حذفه.",
          "proBewertung": "5",
          "loschungData3": "من",
          "price": "185",
          "features": [
            "الدفع في نهاية الخدمة",
            "الدفع فقط مقابل التقييمات المحذوفة",
            "سعر ثابت دون مفاجآت",
            "بدون مخاطر مالية",
            "أنت تطلب ونحن نحذف"
          ]
        }
      ],
      "Wunschplattform": [
        {
          "title": "المنصة المخصصة مبتدئ",
          "proBewertung": "25",
          "price": "650",
          "features": [
            "مستخدمون محليون موثقون",
            "وتيرة مخصصة",
            "نصوص مخصصة"
          ]
        },
        {
          "title": "المنصة المخصصة بزنس",
          "proBewertung": "50",
          "price": "1200",
          "features": [
            "مستخدمون محليون موثقون",
            "وتيرة مخصصة",
            "نصوص مخصصة",
            "لوحة تحكم شخصية"
          ]
        },
        {
          "title": "المنصة المخصصة برو",
          "proBewertung": "100",
          "price": "1950",
          "features": [
            "مستخدمون محليون موثقون",
            "وتيرة مخصصة",
            "نصوص مخصصة",
            "لوحة تحكم شخصية",
            "قابل للتوزيع على عدة ملفات/مواقع شخصية"
          ]
        }
      ]
    }
  ],

  // Imprint
  "impressum_step1_title": "المسؤول عن المحتوى وفقاً لـ § 55 Abs. 2 RStV:",
  "impressum_step1_description": "Taliqat123، العنوان كما هو مذكور أعلاه",
  "impressum_step2_title": "حل النزاعات في الاتحاد الأوروبي",
  "impressum_step2_description": "توفر المفوضية الأوروبية منصة لحل النزاعات عبر الإنترنت (RLL): https://ec.europa.eu/consumers/odr. ستجد عنوان بريدنا الإلكتروني أعلاه في بيانات الشركة.",
  "impressum_step3_title": "حل نزاعات المستهلكين / وسيط التجارة",
  "impressum_step3_description": "نحن لسنا مستعدين أو ملزمين بالمشاركة في إجراءات حل النزاعات أمام وسيط المستهلكين.",
  "impressum_step4_title": "مسؤولية المحتوى",
  "impressum_step4_description": "لا يتحمل مشغل الموقع أي مسؤولية عن المعلومات المرسلة أو المخزنة من قبل أطراف ثالثة. مشغل الموقع ليس ملزماً بمراقبة هذه المعلومات. مشغل الموقع مسؤول فقط إذا لم يمتثل لطلب مشروع بحذف المعلومات، وذلك فقط عندما يتم إرسال المعلومات أو تخزينها بشكل غير قانوني من قبل أطراف ثالثة. سيتم حذف المعلومات غير القانونية بشكل واضح فور الإبلاغ عنها.",
  "impressum_step5_title": "مسؤولية الروابط",
  "impressum_step5_description": "ليس لمشغل الموقع أي سيطرة على الروابط الخارجية. قبل نشر الروابط على هذه الصفحات، تم التحقق منها بشكل معقول لضمان امتثالها للأحكام القانونية. مشغل الموقع ليس مسؤولاً عن التغييرات التي قد تحدث على الصفحات التي يمكن الوصول إليها عبر الروابط الخارجية. على وجه الخصوص، فإن المراقبة المستمرة للروابط الخارجية للتحقق من الانتهاكات القانونية المحتملة ليست معقولة. إذا تم إبلاغ مشغل الموقع بمحتويات غير قانونية يمكن الوصول إليها عبر الروابط الخارجية، فسيحذف هذه الروابط فوراً.",
  "impressum_step6_title": "حقوق النشر",
  "impressum_step6_description": "حقوق النشر لجميع النصوص والمحتويات الإعلامية المتعددة التي يمكن الوصول إليها على صفحات المشغل مملوكة لمشغل الموقع، ما لم يتم الإشارة إلى حقوق نشر منفصلة. إذا لم يتم ذكر حقوق نشر لأطراف ثالثة، فيرجى إبلاغنا عبر البريد الإلكتروني. سيقوم مشغل الموقع بحذف هذه المحتويات بسرعة. لا يُسمح بمعالجة المحتوى وتوزيعه واستنساخه دون موافقة صريحة من مشغل الموقع.",

  // Privacy Policy
  "datenschutz_title1": "عام",
  "datenschutz_description1": "تتم معالجة بياناتك الشخصية بالمعنى المقصود في المادة 4 الفقرة 1 من اللائحة العامة لحماية البيانات (GDPR) (مثل اللقب والاسم، والعنوان، وعنوان البريد الإلكتروني، ومعلومات الدفع) من قبلنا فقط وفقاً لأحكام قانون حماية البيانات الألماني ومع الأخذ في الاعتبار اللائحة العامة لحماية البيانات (GDPR) للاتحاد الأوروبي. تعلمك الأحكام التالية بطبيعة ونطاق وهدف جمع البيانات الشخصية ومعالجتها واستخدامها.",
  "datenschutz_description2": "تعد معالجة البيانات الشخصية بالمعنى المقصود في المادة 4 الفقرة 2 من اللائحة العامة لحماية البيانات قانونية وفقاً للمادة 6 من اللائحة العامة لحماية البيانات عند توفر أحد الشروط التالية:",
  "datenschutz_description_list": "<li>أعطى الشخص المعني موافقته على معالجة بياناته الشخصية لغرض محدد أو أكثر؛</li> <li>المعالجة ضرورية لتنفيذ عقد يكون الشخص المعني طرفاً فيه أو لتنفيذ تدابير ما قبل العقد بناءً على طلب الشخص المعني؛</li><li>المعالجة ضرورية للامتثال لالتزام قانوني يخضع له المسؤول؛</li><li>المعالجة ضرورية لحماية المصالح الحيوية للشخص المعني أو لشخص طبيعي آخر؛</li> <li>المعالجة ضرورية لأداء مهمة تتم في المصلحة العامة أو في ممارسة السلطة العامة المخولة للمسؤول؛</li> <li>المعالجة ضرورية لتحقيق المصالح المشروعة التي يسعى إليها المسؤول أو طرف ثالث، ما لم تتغلب المصالح أو الحقوق والحريات الأساسية للشخص المعني التي تتطلب حماية البيانات الشخصية، لا سيما عندما يكون الشخص المعني طفلاً.</li>",
  "datenschutz_description3": "تعد معالجة البيانات الشخصية الخاصة (مثل البيانات الصحية) بالمعنى المقصود في المادة 9 الفقرة 1 من اللائحة العامة لحماية البيانات قانونية بشكل خاص وفقاً للمادة 9 الفقرة 2 من اللائحة العامة لحماية البيانات عند توفر أحد الشروط التالية:",
  "datenschutz_description4": "<li>تمت الموافقة الصريحة من الشخص؛</li><li>المعالجة ضرورية لتأكيد أو ممارسة أو الدفاع عن المطالبات القانونية أو في سياق ممارسة الوظائف القضائية.</li>",
  "datenschutz_description5": "لا يتم اتخاذ أي قرار تلقائي أو تنميط بشأن البيانات الشخصية بالمعنى المقصود في المادة 22 من اللائحة العامة لحماية البيانات.",
  "datenschutz_description6": "يضمن المشغل أمن البيانات وفقاً للمادة 32 من اللائحة العامة لحماية البيانات، مع الأخذ في الاعتبار مبدأ التناسب، من خلال التدابير التقنية المناسبة. في حالة حدوث انتهاك لحماية البيانات، سيتم إخطار السلطة الرقابية المختصة وفقاً للمادة 33 من اللائحة العامة لحماية البيانات، وكذلك الشخص المعني وفقاً للمادة 34 من اللائحة العامة لحماية البيانات.",
  "datenschutz_title2": "نطاق التطبيق",
  "datenschutz_description7": "تنطبق سياسة الخصوصية هذه فقط على مواقعنا الإلكترونية. إذا تمت إعادة توجيهك إلى مواقع أخرى عبر روابط على صفحاتنا، فيرجى الاستفسار هناك حول معالجة بياناتك.",
  "datenschutz_title3": "ملفات تعريف الارتباط (Cookies)",
  "datenschutz_description8": "يستخدم هذا الموقع ملفات تعريف الارتباط للتعرف على زواره. لا يتم نقل البيانات التي تم الحصول عليها من خلال ملفات تعريف الارتباط إلى أطراف ثالثة. إذا كنت ترغب في منع تخزين ملفات تعريف الارتباط، فلديك خيار تعطيلها في إعدادات متصفحك.",
  "datenschutz_title4": "خطوط جوجل",
  "datenschutz_decsription9": "تستخدم هذه المواقع الإلكترونية خطوطاً خارجية، وهي خطوط جوجل. خطوط جوجل هي خدمة تقدمها شركة جوجل ('Google'). يتم دمج هذه الخطوط من خلال طلب خادم، عادةً خادم تابع لجوجل في الولايات المتحدة. وبالتالي يتلقى الخادم معلومات حول صفحات الإنترنت التي زرتها. كما يتم تخزين عنوان IP لمتصفح الجهاز الذي يستخدمه زائر هذه المواقع بواسطة جوجل.",
  "datenschutz_decsription10": "يمكنك العثور على معلومات إضافية في أحكام حماية البيانات الخاصة بجوجل، المتاحة هنا:",
  "datenschutz_title5": "تحليلات جوجل",
  "datenschutz_description11": "يستخدم هذا الموقع تحليلات جوجل، وهي خدمة تحليل ويب مقدمة من شركة جوجل ('Google'). تستخدم تحليلات جوجل ملفات تعريف الارتباط، وهي ملفات نصية يتم وضعها على جهاز الكمبيوتر الخاص بك، لمساعدة الموقع الإلكتروني في تحليل استخدامك له. عادةً ما يتم نقل المعلومات التي تم إنشاؤها بواسطة ملفات تعريف الارتباط حول استخدامك لهذا الموقع إلى خوادم في الولايات المتحدة وتخزينها هناك. في حالة تفعيل إخفاء هوية عنوان IP على هذا الموقع، سيتم تقصير عنوان IP الخاص بك بواسطة جوجل مسبقاً في الدول الأعضاء في الاتحاد الأوروبي أو في الدول الأخرى الموقعة على اتفاقية المنطقة الاقتصادية الأوروبية. في حالات استثنائية، سيتم نقل عنوان IP الكامل إلى خادم جوجل في الولايات المتحدة وتقصيره هناك.",
  "datenschutz_description12": "نيابة عن مشغل هذا الموقع، ستستخدم جوجل هذه المعلومات لتقييم استخدامك للموقع، وإعداد تقارير حول نشاط الموقع وتقديم خدمات أخرى مرتبطة باستخدام الموقع واستخدام الإنترنت لمشغل الموقع. لن يتم دمج عنوان IP المرسل من متصفحك في إطار تحليلات جوجل مع بيانات أخرى من جوجل.",
  "datenschutz_description13": "يمكنك رفض استخدام ملفات تعريف الارتباط عن طريق تحديد الإعدادات المناسبة في متصفحك. يرجى ملاحظة أنه إذا فعلت ذلك، فقد لا تتمكن من استخدام جميع وظائف هذا الموقع الإلكتروني.",
  "datenschutz_description14": "يمكنك أيضاً منع جمع البيانات التي تم إنشاؤها بواسطة ملف تعريف الارتباط والمتعلقة باستخدامك للموقع (بما في ذلك عنوان IP الخاص بك) بواسطة جوجل، وكذلك معالجة هذه البيانات بواسطة جوجل، عن طريق تنزيل وتثبيت ملحق المتصفح المتاح عبر الرابط التالي:",
  "datenschutz_description15": "يتم استخدام وظيفة إخفاء هوية تحليلات جوجل. تم إبرام عقد معالجة مع شركة جوجل.",
  "datenschutz_title6": "مدير علامات جوجل / إعلانات جوجل",
  "datenschutz_description17": "مدير علامات جوجل هو حل يسمح للمسوقين بإدارة علامات مواقع الويب من خلال واجهة. أداة مدير العلامات نفسها (التي تنفذ العلامات) هي نطاق بدون ملفات تعريف ارتباط ولا تجمع أي بيانات شخصية. تعمل الأداة على تشغيل علامات أخرى يمكنها، بدورها، جمع البيانات. لا يصل مدير علامات جوجل إلى هذه البيانات. إذا تم إجراء إلغاء تنشيط على مستوى النطاق أو ملفات تعريف الارتباط، فسيظل صالحاً لجميع علامات التتبع التي يتم تنفيذها عبر مدير علامات جوجل.",
  "datenschutz_description18": "تنطبق أحكام الخصوصية لشركة جوجل على البيانات المعنية. لمزيد من المعلومات حول سياسات الخصوصية في جوجل، يرجى زيارة الرابط التالي:",
  "datenschutz_description19": "تم إبرام عقد معالجة مع شركة جوجل.",
  "datenschutz_title7": "باي بال",
  "datenschutz_description20": "عند الدفع عبر باي بال، أو بطاقة الائتمان عبر باي بال، أو الخصم المباشر عبر باي بال، أو الدفع عند الفاتورة، وكذلك الدفع بالتقسيط عبر باي بال، فإننا ننقل بيانات الدفع الخاصة بك إلى باي بال (أوروبا) S.à r.l. et Cie, S.C.A.، 22-24 Boulevard Royal, L-2449 Luxembourg (يشار إليها فيما يلي بـ 'PayPal') في إطار عملية الدفع. لطرق الدفع ببطاقة الائتمان عبر باي بال، أو الخصم المباشر عبر باي بال، أو الدفع عند الفاتورة عبر باي بال، وكذلك الدفع بالتقسيط عبر باي بال، تحتفظ باي بال بالحق في التحقق من الجدارة الائتمانية. تستخدم باي بال نتيجة هذا التحقق من الجدارة الائتمانية للبت في توفير طريقة الدفع المعنية. يمكن أن يتضمن تقييم الجدارة الائتمانية قيم احتمالية (درجات). إذا تم استخدام الدرجات في إطار تقييم الجدارة الائتمانية، فإنها تستند إلى طريقة إحصائية معترف بها رياضياً. تؤخذ بيانات العنوان، من بين أمور أخرى، في الاعتبار عند حساب الدرجات.",
  "datenschutz_decsription20_1": "لمزيد من المعلومات حول حماية البيانات، لا سيما بشأن وكالات المعلومات المستخدمة، يرجى الاطلاع على سياسة الخصوصية الخاصة بباي بال:",
  "datenschutz_title8": "أمان بياناتك / تشفير SSL",
  "datenschutz_description21": "وفقاً للوائح القانونية وفقاً للمادة 13 الفقرة 7 من TMG، يستخدم هذا الموقع تشفير SSL، يمكن التعرف عليه من خلال رمز القفل في شريط عنوان متصفحك. لا يمكن قراءة البيانات المرسلة من قبل أطراف ثالثة عند تفعيل تشفير SSL.",
  "datenschutz_description22": "عادةً ما يكون هذا تشفير 256 بت. إذا كان متصفحك لا يدعم تشفير 256 بت، فإننا نستخدم تقنية v3 بـ 128 بت. يمكنك التعرف على ما إذا كانت صفحة معينة من موقعنا الإلكتروني يتم نقلها بشكل مشفر عن طريق التحقق من وجود رمز قفل مغلق في شريط الحالة السفلي لمتصفحك.",
  "datenschutz_description23": "نطبق تدابير أمنية تقنية وتنظيمية مناسبة (TOM) لحماية بياناتك من أي تلاعب عرضي أو متعمد، أو فقدان جزئي أو كلي، أو تدمير، أو وصول غير مصرح به من قبل أطراف ثالثة. يتم تحسين تدابيرنا الأمنية باستمرار وفقاً للتطورات التكنولوجية.",
  "datenschutz_title9": "حقوق الأشخاص المعنيين",
  "datenschutz_description24": "يحق لك طلب معلومات في أي وقت ومجاناً حول البيانات الشخصية المخزنة عنك. تشمل حقوقك أيضاً التأكيد والتصحيح والقيود والحظر والحذف لهذه البيانات، فضلاً عن تقديم نسخة من البيانات بصيغة قابلة للنقل، وكذلك سحب الموافقة الممنوحة والاعتراض. تظل الالتزامات القانونية بالاحتفاظ بالبيانات دون تغيير.",
  "datenschutz_description25": "تستند حقوقك بشكل خاص إلى الأحكام التالية من اللائحة العامة لحماية البيانات:",
  "datenschutz_list26": "<li>المادة 7 الفقرة 3 - الحق في سحب موافقتك المتعلقة بحماية البيانات</li><li>المادة 12 - المعلومات الشفافة والاتصال وآليات ممارسة حقوق الشخص المعني</li> <li>المادة 13 - الالتزام بالإبلاغ عند جمع البيانات الشخصية من الشخص المعني</li> <li>المادة 14 - الالتزام بالإبلاغ عندما لا يتم جمع البيانات الشخصية من الشخص المعني</li> <li>المادة 15 - حق الوصول للشخص المعني، والحق في التأكيد وتقديم نسخة من البيانات الشخصية</li> <li>المادة 16 - حق التصحيح</li> <li>المادة 17 - الحق في المحو ('الحق في النسيان')</li><li>المادة 18 - الحق في تقييد المعالجة</li> <li>المادة 19 - الالتزام بالإبلاغ في حالة تصحيح أو حذف البيانات الشخصية أو تقييد المعالجة</li> <li>المادة 20 - الحق في نقل البيانات</li> <li>المادة 21 - حق الاعتراض</li> <li>المادة 22 - الحق في عدم الخضوع لقرار يستند حصرياً إلى معالجة آلية، بما في ذلك التنميط</li> <li>المادة 77 - الحق في تقديم شكوى إلى سلطة رقابية</li>",

  // Terms and Conditions (AGB)
  "agb_title1": "1. أحكام عامة",
  "agb_description1": "تدير Taliqat123 على الإنترنت، من بين أمان أخرى تحت نطاق Taliqat123.com.sa، تطبيقاً برمجياً قابلاً للاستخدام عبر الإنترنت (يشار إليه فيما يلي بـ 'الخدمة') يدعم رواد الأعمال في أنشطتهم على المنصات التجارية. مقدم الخدمة هو Taliqat123، طريق الملك فهد، حي العليا، الرياض 12211، المملكة العربية السعودية (يشار إليه فيما يلي بـ 'Taliqat123'). تنطبق هذه الشروط والأحكام على جميع علاقات العمل الحالية والمستقبلية بين المستخدم وTaliqat123. لا تشكل الشروط والأحكام العامة للمستخدم (بما في ذلك شروط الشراء وشروط الطلب، إلخ) التي تختلف أو تتعارض أو تكمل هذه الشروط والأحكام العامة جزءاً من العقد، ما لم يتم الاتفاق على صلاحيتها صراحة عند إبرام العقد. يتم رفض أي إشارة عامة إلى الشروط والأحكام العامة للمستخدم بشكل صريح.",
  "agb_title2": "2. إبرام العقد",
  "agb_description2": "موضوع عقد الاستخدام هو توفير الخدمة لتمكين المستخدم من استخدام وظائفها. يعتمد نطاق الخدمات المعنية، لا سيما الوظيفة التقنية وطبيعة ونطاق الخدمات المقدمة، على الباقة المختارة عند التسجيل. يحدد وصف الخدمات النطاق المعني لخدمات الباقة. تحتفظ Taliqat123 أيضاً بحق تقديم خدمات إضافية تتجاوز الباقة المختارة. يتم تحديد تكلفة ونطاق الخدمات الإضافية المعنية أيضاً من خلال وصف الخدمات وقائمة الأسعار المعمول بها. لاستخدام الخدمة، يجب أن يكون لدى المستخدم اتصال بالإنترنت وجهاز متوافق مع الإنترنت ومتصفح إنترنت حديث، على نفقته الخاصة. لا يتمثل موضوع العقد في تحقيق نجاح مبيعات معين على المنصات التجارية. توفر Taliqat123 فقط إمكانية استخدام خدمات معينة، ويعتبر استخدامها الناجح من مسؤولية المستخدم حصرياً.",
  "agb_title3": "3. استخدام الخدمة",
  "agb_description3": "لا يمكن استخدام الخدمة إلا في إطار عقد استخدام. لا يمكن إبرام عقد لاستخدام الخدمة إلا مع رواد الأعمال أو الأشخاص الاعتباريين للقانون العام أو الصناديق الخاصة للقانون العام. يلتزم المستخدم بتقديم معلومات صحيحة عن نفسه وشركته عند إبرام عقد الاستخدام وإبقاء بياناته محدثة باستمرار. تقدم Taliqat123 إبرام عقود استخدام مدفوعة. من خلال ملء النموذج ذي الصلة وإرساله، يصرح المستخدم برغبته في إبرام عقد مع Taliqat123 لاستخدام الخدمات. قبل إرسال النموذج، تتاح للمستخدم الفرصة للتحقق من معلوماته الشخصية أو المتعلقة بشركته وتصحيحها إذا لزم الأمر عن طريق تعديل الحقول المعنية. يمكنه أيضاً التحقق من الخدمات التي اختارها وتعديلها عن طريق تحديد المربعات المعنية. من خلال النقر على الزر المعني، يقدم المستخدم عرضاً ملزماً لإبرام عقد استخدام. تقبل Taliqat123 العرض عن طريق إرسال تأكيد طلب يحتوي أيضاً على بيانات الوصول إلى الخدمات. يمكن إبرام العقد باللغة العربية أو، وفقاً للمنصة المستخدمة، باللغة الإنجليزية. تحتفظ Taliqat123 بنص العقد، لكنه غير متاح للعميل.",
  "agb_title4": "4. توفير الخدمة",
  "agb_description4": "يتم توفير الخدمة للمستخدم من قبل Taliqat123 بعد تنشيطها. نقطة تسليم الخدمة هي مخرج الراوتر في مركز بيانات Taliqat123. تضمن Taliqat123 توافر الخدمة بنسبة 97% في المتوسط السنوي عند نقطة التسليم.",
  "agb_title5": "5. حق الاستخدام، الحقوق",
  "agb_description5": "تمنح Taliqat123 المستخدم حقاً بسيطاً وغير حصري وغير قابل للتحويل لاستخدام الخدمة لأغراض تجارية طوال مدة العقد. لا يتم منح أي حقوق أخرى للمستخدم. لا يحق للمستخدم على وجه الخصوص إتاحة الخدمة لأطراف ثالثة أو تقديم خدمات لأطراف ثالثة من خلال الخدمة. لا ينطبق هذا الحظر على مقدمي الخدمات الذين يعملون مباشرة نيابة عن العميل. بقدر ما يتم إنشاء قاعدة بيانات أو أعمال قاعدة بيانات على خادم Taliqat123 أثناء مدة عقد الاستخدام، يتم منح جميع الحقوق المتعلقة بها للمستخدم. يظل المستخدم أيضاً مالكاً لقواعد البيانات أو أعمال قواعد البيانات بعد انتهاء العقد.",
  "agb_title6": "6. الرسوم، الدفع",
  "agb_description6": "إذا كان استخدام الخدمة مدفوعاً، يتم تحديد التكاليف وفقاً للمعلومات الواردة في قائمة الأسعار المعنية. جميع الأسعار لا تشمل ضريبة القيمة المضافة القانونية. يجب سداد جميع المدفوعات وفقاً لوصف الخدمة المعنية ويمكن إجراؤها عبر طرق الدفع المقدمة. إذا اتفق الطرفان على الخصم المباشر، فإن المستخدم يأذن لـ Taliqat123 بخصم المبالغ المستحقة، بما في ذلك المدفوعات المتكررة وديون المبالغ المتغيرة، باستخدام تفويض خصم مباشر من نظام المدفوعات المحلي. يتم تقليل فترة الإشعار المسبق (الإشعار المسبق) إلى يوم واحد، بالقدر الذي يسمح به القانون. يتعهد المستخدم بضمان وجود رصيد كافٍ في حسابه. تتحمل العميل التكاليف الناتجة عن عدم الدفع أو رفض أمر الدفع، طالما أن عدم الدفع أو الرفض لا يُعزى إلى Taliqat123. بالإضافة إلى ذلك، تفرض Taliqat123 رسوم معالجة بقيمة 10 ريال سعودي صافية. يتم إرسال الفواتير الصادرة عن Taliqat123 إلكترونياً عبر البريد الإلكتروني. بالإضافة إلى ذلك، يمكن لـ Taliqat123 السماح للمستخدم بتنزيل مستندات الفواتير بنفسه في حساب المستخدم. إذا أراد المستخدم أيضاً تلقي مستندات الفواتير عبر البريد البريدي، يحق لـ Taliqat123 طلب رسوم ثابتة وفقاً لقائمة الأسعار. تعمل Taliqat123 كمنصة وسيطة بين رائد الأعمال والمختبرين. في إطار هذه الوظيفة، تدير Taliqat123 الرصيد الدائن لرائد الأعمال على المنصة لإعادة توزيعها على المراجعين في إطار الحملات المُدارة. يجب استخدام الرصيد الدائن المدفوع لـ Taliqat123 للخدمات المقدمة بواسطة الأداة (دفع المراجعين، شراء الإضافات المُدارة / المُدارة بالكامل). لا يمكن سحب الرصيد الدائن في Taliqat123 نقداً أو تحويله إلى حساب مصرفي.",
  "agb_title7": "7. التزامات المستخدم",
  "agb_description7": "يختار المستخدم بيانات الوصول بغرض استخدام الخدمة. يلتزم المستخدم بالحفاظ على سرية بيانات الوصول هذه وإبلاغ Taliqat123 فوراً في حالة فقدان أو استخدام غير مصرح به لبيانات الوصول من قبل أطراف ثالثة. لا يُسمح للمستخدم بتقديم بيانات الوصول لأطراف ثالثة. يحق لـ Taliqat123 حظر بيانات الوصول في حالة الاشتباه في استخدام غير مصرح به أو سوء استخدام للبيانات. لا يجوز للمستخدم استخدام الخدمة إلا لاحتياجاته التجارية الخاصة. يتعهد المستخدم بعدم استخدام الخدمات للترويج لعروض منافسة لـ Taliqat123 أو لجمع بيانات أو بيانات الاتصال لأطراف ثالثة داخل الخدمات والتواصل مع هذه الأطراف الثالثة خارج الخدمات أو إقامة علاقات تعاقدية معهم. إذا لاحظ المستخدم أن الخدمة لا تعمل أو لا تعمل بشكل صحيح، فإنه ملزم بإبلاغ Taliqat123 بذلك كتابياً على الفور.",
  "agb_title8": "8. حماية البيانات",
  "agb_description8": "سيمتثل الطرفان لأحكام حماية البيانات المعمول بها، لا سيما الأحكام السارية في المملكة العربية السعودية. يحق لـ Taliqat123 تقييم بيانات المستخدمين إحصائياً بشكل مجهول واستخدامها لأغراضها الخاصة، بما في ذلك لأغراض إعلانية. يخدم هذا بشكل خاص التطوير الإضافي للخدمات.",
  "agb_title9": "9. المسؤولية",
  "agb_description9": "تتحمل Taliqat123 المسؤولية تجاه المستخدم عن جميع الأضرار التي يسببها هو نفسه أو ممثلوه القانونيون أو وكلاؤه التنفيذيون بشكل متعمد أو بسبب إهمال جسيم. في حالة الإهمال البسيط، تتحمل Taliqat123 المسؤولية دون قيود في حالة انتهاك الحياة أو الجسم أو الساق. في جميع الحالات الأخرى، تقتصر مسؤولية Taliqat123 على الحالات التي تم فيها انتهاك التزام تعاقدي جوهري. الالتزامات التعاقدية الجوهرية هي تلك التي تعتبر ضرورية لتحقيق هدف العقد وتلك التي قد يؤدي انتهاكها إلى تعريض تحقيق هدف العقد للخطر. في هذه الحالات، تقتصر المسؤولية على تعويض الأضرار المتوقعة والنموذجية. تُستبعد المسؤولية المستقلة عن الذنب لـ Taliqat123 وفقاً للأنظمة المعمول بها عن العيوب الموجودة وقت إبرام العقد، دون المساس بالفقرات السابقة. تظل المسؤولية بموجب قانون مسؤولية المنتج دون تغيير.",
  "agb_title10": "10. المدة، الإنهاء",
  "agb_description10": "تبدأ مدة عقد الاستخدام المدفوع للخدمة من التنشيط بواسطة Taliqat123 وتستمر إلى أجل غير مسمى بفترات شهرية. إذا اختار المستخدم فترة دفع أخرى، يتم تمديد مدة العقد وفقاً لفترة الدفع المختارة. يتم تمديد مدة عقد الاستخدام المدفوع للخدمة تلقائياً بمدة العقد المعنية، ما لم يتم إنهاؤه في الوقت المحدد. إذا تجاوزت مدة استخدام الخدمات، لا سيما الخدمات الإضافية، مدة العقد، فلا يمكن إنهاء العقد قبل انتهاء مدة الخدمات الإضافية. يجب أن يتم الإنهاء، بما في ذلك إنهاء Taliqat123، كتابياً مع مراعاة فترة إشعار مدتها أسبوعين قبل نهاية الفترة المعنية. يظل الحق في الإنهاء الفوري لسبب مهم قائماً. يجب أن يتم هذا الإنهاء كتابياً أيضاً. إذا توقف المستخدم عن استخدام الخدمة قبل انقضاء فترة الإنهاء، فإن التزامه بدفع الرسوم يظل دون تغيير. إذا كان العميل متأخراً في دفع التكاليف الشهرية أو التزامات الدفع الأخرى، باستثناء التأخر البسيط، يحق لـ Taliqat123 سحب الإذن باستخدام الخدمات حتى يتم استيفاء التأخر بالكامل و/أو رفض تقديم خدمات إضافية. يظل الحق في الإنهاء الفوري لسبب مهم قائماً بالإضافة إلى الحق في سحب إذن الاستخدام.",
  "agb_title11": "11. تعديلات هذه الشروط والأحكام، نقل الحقوق",
  "agb_description11": "يحق لـ Taliqat123 تعديل الأحكام المتعلقة بالخدمات التي يجب تقديمها بشكل معقول مع الأخذ في الاعتبار المتطلبات التقنية وظروف السوق، بالقدر المعقول للمستخدم. يتم نشر التعديلات على هذه الشروط والأحكام العامة في الخدمة. يتم إبلاغ المستخدم بالتعديلات على الشروط والأحكام العامة التي لا تندرج تحت الفقرة 1 كتابياً. تصبح التعديلات سارية إذا لم يعترض المستخدم على التعديلات في غضون 14 يوماً من استلام إشعار التعديل كتابياً. يتم إبلاغ المستخدم بأهمية صمته إلى جانب إشعار التعديل. إذا اعترض المستخدم على التعديلات، يحق لـ Taliqat123 إنهاء العقد بشكل عادي في نهاية فترة الصلاحية. إذا لم تمارس Taliqat123 حق الإنهاء هذا، يستمر العقد وفقاً للشروط السارية حتى الآن.",
  "agb_title12": "12. الأحكام الختامية",
  "agb_description12": "يطبق قانون المملكة العربية السعودية. لا تنطبق أحكام اتفاقية الأمم المتحدة بشأن عقود البيع الدولي للبضائع. إذا كان المستخدم تاجراً أو شخصاً اعتبارياً للقانون العام أو كياناً للقانون العام، فإن المحكمة المختصة حصرياً لجميع النزاعات الناشئة عن هذا العقد هي المقر الرئيسي لـ Taliqat123. ينطبق الشيء نفسه إذا لم يكن للمستخدم موطن عام في المملكة العربية السعودية أو إذا كان محل إقامته أو إقامته المعتادة غير معروفين وقت رفع الدعوى القضائية.",

}